import { render } from "./ticketModel.vue?vue&type=template&id=13b4e91c"
import script from "./ticketModel.vue?vue&type=script&lang=js"
export * from "./ticketModel.vue?vue&type=script&lang=js"

import "./ticketModel.vue?vue&type=style&index=0&id=13b4e91c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__